export default "__VITE_ASSET__aad1acfa__"